import {OtsInlineAlert} from "../components/OtsInlineAlert";

export function ActiveShiftFocusNotice({
  driver,
  count,
  loading,
  listView,
  onDismiss,
}: {
  driver: string;
  count?: number;
  loading?: boolean;
  listView?: boolean;
  onDismiss: () => void;
}) {
  return (
    <OtsInlineAlert size="compact" onDismiss={onDismiss} className="shrink-0">
      <div className="flex flex-wrap items-baseline gap-x-2">
        <span className="font-semibold">Driver focus: {driver}</span>
        <span>
          {loading || count == null
            ? "Finding visible rows…"
            : count > 0
            ? `${count} visible row${count === 1 ? " is" : "s are"} highlighted.`
            : "No matching rows are visible for this date, category and filters."}{" "}
          {listView && "List view is active; dismiss focus to restore your saved view. "}
        </span>
        {!loading && count === 0 && <span>Saved filters and the Water/Oil category still apply.</span>}
      </div>
    </OtsInlineAlert>
  );
}
